<script setup>

import { useElementSize } from '@vueuse/core'

const cover = ref(null)
const { width } = useElementSize(cover)

</script>

<template>
	<div ref="cover">
		<div
			class="dark:bg-dark8 bg-lightBg8 aspect-[3/4] flex flex-col justify-center"
			:class="`p-[${width > 280 ? Math.round(width/14) : '20'}px]`"	
	>
			<FormNewsletter :cover="true" :width="width" />
		</div>
	</div>
</template>